import { removeCookie } from 'tiny-cookie'

// TODO Create MathHelpers.ts for this and other functions?
export function sum(values: number[]) {
  return values.reduce((total, value) => total + value, 0)
}

export function removeParentCookie(cookieName) {
  removeCookie(cookieName)

  // Remove the cookie from all possible higher domains. Slice off the first
  // segment, which would be covered by the removeCookie above.
  const parts = window.location.hostname.split('.').slice(1)

  for (let i = 0; i < parts.length - 1; i++) {
    removeCookie(cookieName, { domain: parts.slice(i).join('.') })
  }
}

export function isMembershipEvent(event: EventTemplate, tickets: Ticket[]): boolean {
  return event.category === 'Membership' && tickets.some((tg) => tg.handler === 'membership')
}

export function debounce(func: Function, delay = 100) {
  let timer: number
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, delay, event)
  }
}
